import { render, staticRenderFns } from "./EmailBroadcastFilters.vue?vue&type=template&id=a5f3ee72"
import script from "./EmailBroadcastFilters.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports